const selectorDatatableDefault = '#global-datatable';
const selectorInputSearchDefault = '#searchInputTable';
const delayDefault = 500;

import Swal from 'sweetalert2';

import * as helpers from 'tupy-helperjs';
import {flatten, toArray} from "lodash";

/**
 * @param object {Object}
 * @param key {string}
 * @returns {boolean}
 */
function hasProperty(object, key) {
	return Object.prototype.hasOwnProperty.call(object, key);
}

const extractErrors = (errors, messageDefault = "Não foi possível atender o pedido") => {
	let formatted;

	if (errors && hasProperty(errors, "response") && hasProperty(errors?.response || {}, "data")) {
		if (helpers.isObject(errors.response.data.errors)) {
			formatted = flatten(toArray(errors.response.data.errors));
		} else if (hasProperty(errors.response.data, "message")) {
			formatted = [errors.response.data.message];
		} else if (hasProperty(errors.response, "message")) {
			formatted = [errors.response.message];
		} else if (helpers.isObject(errors.response.data)) {
            formatted = flatten(toArray(errors.response.data));
        } else {
			formatted = [errors.response.data];
		}
	} else if (errors && hasProperty(errors, "responseJSON")) {
		if (helpers.isObject(errors.responseJSON.errors)) {
			formatted = flatten(toArray(errors.responseJSON.errors));
		} else if (helpers.isObject(errors.responseJSON)) {
			formatted = flatten(toArray(errors.responseJSON));
		} else if (hasProperty(errors.responseJSON, "message")) {
			formatted = [errors.responseJSON.message];
		} else {
			formatted = [errors.responseJSON];
		}
	} else if (errors && hasProperty(errors, "message")) {
		formatted = [errors.message];
	} else if (errors && hasProperty(errors, "responseText")) {
		formatted = [errors.responseText];
	} else {
		console.debug('formatterErrors', errors);
		formatted = [messageDefault];
	}

	return formatted;
};

window.HelperJS = {
    ...helpers,
    sleep: (ms) => {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    },
	/**
	 *
	 * @param config {DataTable.defaults|{}}
	 * @returns {(DataTable.defaults & {serverSide: boolean, colReorder: boolean, searchDelay: number, pageLength: number, stateSave: boolean, responsive: boolean, processing: boolean, paging: boolean, language: {sSearch: string, searchPlaceholder: string, sLengthMenu: string, sInfo: string, sUrl: string, paginate: {next: string, previous: string}, sInfoEmpty: string, sProcessing: string, sZeroRecords: string, sInfoFiltered: string}, info: boolean, drawCallback: drawCallback}) | {serverSide: boolean, colReorder: boolean, searchDelay: number, pageLength: number, stateSave: boolean, responsive: boolean, processing: boolean, paging: boolean, language: {sSearch: string, searchPlaceholder: string, sLengthMenu: string, sInfo: string, sUrl: string, paginate: {next: string, previous: string}, sInfoEmpty: string, sProcessing: string, sZeroRecords: string, sInfoFiltered: string}, info: boolean, drawCallback: drawCallback}}
	 */
    commonConfigDatatable: (config = {}) => {
        return Object.assign({}, {
			processing: true,
			serverSide: true,
			searchDelay: 1000,
			responsive: true,
			pageLength: 10,
			colReorder: true,
			paging: true,
			info: true,
			language: {
				sProcessing: "<i class='fa fa-spinner fa-spin fa-2x fa-fw'></i><br>Processing",
				sLengthMenu: " _MENU_ registos",
				sZeroRecords: "Sem Resultados",
				sInfo: "<span class='datatables_counter_resume'>A mostrar de _START_ a _END_ | Total:  _TOTAL_ registros </span>",
				sInfoEmpty: "<span  class='datatables_counter_resume'></span>0 registos",
				sInfoFiltered: "<span class='datatables_counter_resume'>(filtrado de _MAX_ total)</span>",
				sSearch: "<span class='font-normal'> <i class='fa fa-search lightblue'></i></span>",
				searchPlaceholder: "Search",
				sUrl: "",
				// oPaginate: {
				//     sFirst: "Primeiro",
				//     sPrevious: "<",
				//     sNext: ">",
				//     sLast: "Último"
				// },
				"paginate": {
					"previous": "<i class='mdi mdi-chevron-left'>",
					"next": "<i class='mdi mdi-chevron-right'>"
				}
			},
			stateSave: false,
			drawCallback: function () {
				$('.dataTables_paginate > .pagination').addClass('pagination-rounded');
			}
		}, config);
    },
    delayQuery: function(callback, ms){
        let timer = 0;
        return function() {
            let context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    },

    searchInputTable: function(selectorDatatable = selectorDatatableDefault, selectorInputSearch = selectorInputSearchDefault, delay = 500){
        $(selectorInputSearch).keyup(HelperJS.delayQuery(function(){
            // if( this.value.length < 3 ) return;
            $(selectorDatatable).DataTable().search(this.value).draw();
        }, delay))
    },

    commonFunctionDatatable: function(selectorDatatable = selectorDatatableDefault, selectorInputSearch = selectorInputSearchDefault, delay = delayDefault){
        setTimeout(() => {
            $('.dataTables_filter').remove();
        }, 10);

        HelperJS.searchInputTable(selectorDatatable, selectorInputSearch, delay);

        $.fn.dataTable.ext.errMode = 'throw';
        $(selectorDatatable).on('error.dt', function(e, settings, techNote, message) {
            console.log(e);
            console.log(settings);
            console.log(techNote);
            console.log(message);
            //function javascript no SeetAlert
            alertErrorDatatable();
        });
    },

    getLang: function() {
        if (navigator.languages !== undefined){
            return navigator.languages[0];
        } else {
            return navigator.language;
        }
    },
    processAlert: function (attributes) {
        if(typeof attributes === 'object'){
            let message = attributes.message;
            let timer = attributes.timer;
            let type = attributes.type;
            let position = attributes.position;
            let typeAlert = attributes.typeAlert;
            switch (typeAlert) {
                case 'swall':
                    swallCustom(message, type, position, timer);
                    break;

                case 'toast':
                    toastMessage(message, type, position, timer);
                    break;

                default:
            }
        }
    },

    lowerBound (num, limit) {
        return num >= limit ? num : limit
    },

	/**
	 *
	 * @param searchParam {string} O valor que deseja atualizar ou adicionar no URL
	 * @param searchValue {string} O valor a adicionar
	 * @param redirect {Boolean} Redirect ou apenas o novo url
	 * @returns {string} | redirect
	 */
	searchQueryString(searchParam, searchValue, redirect = true){
		let url = new URL(document.URL);

		let query_string = url.search;

		let search_params = new URLSearchParams(query_string);

		//Set new param in url
		search_params.set(searchParam, searchValue);

		// change the search property of the main url
		url.search = search_params.toString();

		if(redirect){
			// the new url string
			window.location = url.toString();
		} else {
			return url.toString();
		}
	},

	/**
	 *
	 * @returns array | null
	 */
	getSearchParametersUrl() {
		let params = window.location.search.substr(1);
		return params != null && params !== "" ? HelperJS.transformToAssocArray(params) : {};
	},

	/**
	 *
	 * @param paramsString {string}
	 * @returns array
	 */
	transformToAssocArray( paramsString ) {
		let newParams = {};
		let params = paramsString.split("&");
		for ( let i = 0; i < params.length; i++) {
			let tempParams = params[i].split("=");
			newParams[tempParams[0]] = tempParams[1];
		}
		return newParams;
	},

	/**
	 *
	 * @param input
	 * @returns {string|*}
	 */
	decodeString(input) {
		if (/&amp;|&quot;|&#39;|'&lt;|&gt;/.test(input)) {
			let doc = new DOMParser().parseFromString(input, "text/html");
			return doc.documentElement.textContent;
		}
		return input;
	},

	getUserStorage(){
		return JSON.parse(localStorage.getItem('user'));
	},

	/**
	 * @param {Moment} startDate
	 * @param {Moment} endDate
	 * @returns {number}
	 */
	countWeekDays(startDate, endDate) {
		let start = startDate;
		let weekdayCounter = 0;

		while (start <= endDate) {
			if (start.format('ddd') !== 'Sat' && start.format('ddd') !== 'Sun'){
				weekdayCounter++; //add 1 to your counter if its not a weekend day
			}
			start = moment(start, 'YYYY-MM-DD').add(1, 'days'); //increment by one day
		}

		return weekdayCounter;
	},


	/**
	 * @link https://www.qodo.co.uk/blog/javascript-restrict-keyboard-character-input/
	 * @param myField
	 * @param e
	 * @param restrictionType [digitsOnly, floatOnly, alphaOnly]
	 */
	restrictCharacters(myField, e, restrictionType) {
		switch (restrictionType) {
			case 'digitsOnly':
				restrictionType = /[1234567890]/g;
				break;
			case 'floatOnly':
				restrictionType = /[0-9\.]/g;
				break;
			case 'alphaOnly':
				restrictionType = /[A-Za-z]/g;
				break;

			default:
				return false;

		}

		if (!e) e = window.event
		let code;
		if (e.keyCode) code = e.keyCode
		else if (e.which) code = e.which
		let character = String.fromCharCode(code);
		// if they pressed esc... remove focus from field...
		if (code===27) { this.blur(); return false; }
		// ignore if they are press other keys
		// strange because code: 39 is the down key AND ' key...
		// and DEL also equals .
		if (!e.ctrlKey && code!==9 && code!==8 && code!==36 && code!==37 && code!==38 && (code!==39 || (code===39 && character==="'")) && code!==40) {
			return !!character.match(restrictionType);
		}
	},

	isMobile(){
		let check = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Windows Phone/i;
		return check.test(navigator.userAgent)
	},

	isDesktop(){
		return ! HelperJS.isMobile();
	},

	toSnakeCase(str, separator = '_'){
		str = String(str)
		return str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
			.map(strLower => strLower.toLowerCase())
			.join(separator);
	},

    toSlug(str) {
	    return HelperJS.toSnakeCase(str, '-')
    },

	/**
	 *
	 * @param route {String}
	 * @param nameUser {String}
	 * @param redirectOnSuccess {URL}
	 * @param messageSuccess {String}
	 * @param messageConfirm {String}
	 * @param messageCancel {String}
	 * @param messageError {String}
	 * @param confirmButtonText {String}
	 * @param cancelButtonText {String}
	 * @param {String} typeAlert 'warning', 'info'
	 * @param confirmButtonColor
	 * @param cancelButtonColor
	 */
	alertDelete({
		route,
		nameUser = null,
		redirectOnSuccess = null,
		messageSuccess = 'Apagado com sucesso!',
		messageConfirm = 'Tem certeza que deseja apagar este item?',
		messageCancel = "Ufaaa! Não apagamos nada.",
		messageError = "Não conseguimos processar o pedido, tente novamente mais tarde!",
		confirmButtonText = 'Apagar',
		cancelButtonText = 'Cancelar',
		typeAlert = 'warning',
		confirmButtonColor = '#f1556c',
		cancelButtonColor = '#4fc6e1',
		}){
		const swalWithBootstrapButtons = Swal.mixin({
			buttonsStyling: true
		});

		let htmlReturn = '';

		if(nameUser){
			console.debug(nameUser);
			htmlReturn = `<b>${nameUser}!</b><br/>`;
		}

		htmlReturn = htmlReturn + messageConfirm;

		swalWithBootstrapButtons.fire({
			html: htmlReturn,
			icon: typeAlert,
			showCancelButton: true,
			confirmButtonText: confirmButtonText,
			cancelButtonText: cancelButtonText,
			reverseButtons: true,
			confirmButtonColor: confirmButtonColor,
			cancelButtonColor: cancelButtonColor,
		}).then((result) => {
			if (result.value) {
				axios.delete(route).then(response => {
					toastSuccess(messageSuccess);

					if(redirectOnSuccess){
						location.href = redirectOnSuccess
					}

					return response.data;
				}).catch(error => {
					toastError(messageError);
					console.error('Error delete server', error.response)

					return error
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				toastInfo(messageCancel);
				return 'cancel';
			}
		}).catch(error => {
			toastError(messageError)
			console.error('error delete', error)
			return error
		});
	},

	generateMonths(limitRange = 12) {

		// let init = momentJS();
		let init = new Date();

		let months = [];

		// let optionDate = { year: 'numeric', month: 'long' };

		for (let i = 0; i < limitRange; i++) {
			months.push({
				name: init.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' }),
				value: init.toISOString(),
			})
			init.setMonth(init.getMonth() + 1);
		}
		// console.table(months)
		return months
	},

	monthViewEvent(data){
		return new Date(data).toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' })
	},

    formatterErrors(object){
		return extractErrors(object)
    },

	extractErrors,
};

window.deleteEntryDatatable = (buttonVar, nameUser = false, message = 'Tem certeza que deseja apagar este item?') => {
  	let button = $(buttonVar);
  	let route = button.attr('data-route');
  	let row = $("a[data-route='"+route+"']").closest('tr');

  	const swallWithBootstrapButtons = Swal.mixin({
        buttonsStyling: true
    });

    let htmlReturn = '';

    if(nameUser){
    	htmlReturn = `<b>${nameUser}!</b><br/>`;
    }

    htmlReturn = htmlReturn + message;

    swallWithBootstrapButtons.fire({
        html: htmlReturn,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
    }).then((result) => {
        if (result.value) {
            axios.delete(route).then(response => {
	  			toastSuccess('Apagado com sucesso!');

		        // Remove the row from the datatable
		        row.remove();
		    }).catch(error => {
		        toastError(error.response.data.message);
		        // console.log(error)
		    });

        } else if (result.dismiss === Swal.DismissReason.cancel) {
        	toastInfo();
        }
    }).catch(error => {
        toastError()
    });
};

window.chunkArray = (array, size) => {
    let result = []
    for (let i = 0; i < array.length; i += size) {
        let chunk = array.slice(i, i + size)
        result.push(chunk)
    }
    return result
}
